import type { TabNavToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useTabNavTokens = (theme: Theme): TabNavToken => {
  const { color, borderRadius, spacing, component } = theme;
  const base = {
    active: color.primary,
    borderRadius: borderRadius.md,
    height: 'auto',
    width: 'auto',
    padding: spacing.md,
    background: {
      active: color.primaryVariant,
      default: color.surfaceContainerVariant,
      hover: color.primaryVariantHover,
    },
    text: {
      active: color.onSurface,
      default: color.onSurface,
      hover: color.onSurface,
    },
  };

  return merge({}, base, component?.tabNav) as TabNavToken;
};
